import { render } from "./collectionRecord.vue?vue&type=template&id=e55205de&scoped=true"
import script from "./collectionRecord.vue?vue&type=script&lang=js"
export * from "./collectionRecord.vue?vue&type=script&lang=js"

import "./collectionRecord.vue?vue&type=style&index=0&id=e55205de&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e55205de"]])

export default __exports__